module.exports = __webpack_public_path__ + "static/img/comtop-six.6a949d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/comtop-six.png
// module id = PLdw
// module chunks = 0